import { Controller } from 'stimulus';

// The Join button of a live event block on the post page (Block::Newsletter::LiveEventComponent#web_action).
// The server renders the right state for the moment of the request; this moves it on as time passes, without a
// reload: no button until an hour before the start (opensAt, epoch ms), "Join" from then, and "Finished" once
// endsAt (epoch ms, only sent for a premiere; a stream finishes when it is ended, which the next load shows)
// has passed. Both are absolute, so the page's clock is the only input.

const TICK_MS = 15000;

// "Tue, 12:15 PM – 1:15 PM EDT" in the viewer's zone, shaped like EventComponent#time_label.
function timeLabel(start, end) {
  const clock = new Intl.DateTimeFormat(undefined, { hour: 'numeric', minute: '2-digit' });
  const weekday = new Intl.DateTimeFormat(undefined, { weekday: 'short' });
  const zone = new Intl.DateTimeFormat(undefined, { timeZoneName: 'short' })
    .formatToParts(start)
    .find(part => part.type === 'timeZoneName');
  let range = clock.format(start);
  if (end) {
    const nextDay = end.toDateString() !== start.toDateString();
    range += ` – ${nextDay ? `${weekday.format(end)}, ` : ''}${clock.format(end)}`;
  }
  return `${weekday.format(start)}, ${range}${zone ? ` ${zone.value}` : ''}`;
}

export default class extends Controller {
  static targets = ['join', 'finished', 'month', 'day', 'time'];
  static values = { opensAt: Number, endsAt: Number, startsAt: Number, displayEndsAt: Number, finished: Boolean };

  connect() {
    this.localize();
    this.update();
    this.timer = setInterval(() => this.update(), TICK_MS);
  }

  disconnect() {
    clearInterval(this.timer);
  }

  // The server renders the time in the author's zone (all the email and a script-less page can show); a
  // viewer reads it in their own. Keeps the server text if the browser can't format it.
  localize() {
    if (!this.hasStartsAtValue || !this.startsAtValue) return;

    try {
      const start = new Date(this.startsAtValue);
      const end = this.hasDisplayEndsAtValue && this.displayEndsAtValue ? new Date(this.displayEndsAtValue) : null;
      const label = timeLabel(start, end);
      const month = new Intl.DateTimeFormat('en-US', { month: 'short' }).format(start).toUpperCase();
      const day = String(start.getDate());

      this.timeTargets.forEach(el => (el.textContent = label));
      this.monthTargets.forEach(el => (el.textContent = month));
      this.dayTargets.forEach(el => (el.textContent = day));
    } catch (e) {
      // Leave the server-rendered text.
    }
  }

  update() {
    const now = Date.now();
    // A block the server rendered as finished (finishedValue) never goes back to Join.
    const finished = this.finishedValue || (this.hasEndsAtValue && this.endsAtValue > 0 && now >= this.endsAtValue);
    const joinable = !finished && this.hasOpensAtValue && now >= this.opensAtValue;

    this.joinTargets.forEach(el => el.classList.toggle('hidden', !joinable));
    this.finishedTargets.forEach(el => el.classList.toggle('hidden', !finished));
  }
}
